var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group',[_c('b-form-input',{attrs:{"value":_vm.text,"readonly":""}}),_c('b-button',{attrs:{"variant":_vm.copied ? 'outline-success' : 'outline-secondary'},on:{"click":function($event){return _vm.copyToClipboard(_vm.text)}}},[_c('i',{staticClass:"fa fa-copy"}),_vm._v(" "+_vm._s(_vm.copied ? 'Gekopieerd!' : '')+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }